import { render, staticRenderFns } from "./LawLeaderDept.vue?vue&type=template&id=1a693b95&"
import script from "./LawLeaderDept.vue?vue&type=script&lang=js&"
export * from "./LawLeaderDept.vue?vue&type=script&lang=js&"
import style0 from "./LawLeaderDept.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports